import { BodyLong, Content, Heading, VerticalSpace } from '@elhub/ds-components'
import styled from 'styled-components'
import TopContainer from 'components/TopContainer/TopContainer'

import React from 'react'
import { useTranslation } from 'react-i18next'

import { useFetchMetaData } from '../hooks/useFetchMetaData'
import { LabelMessages } from '../locales/messages/label'
import DatasetTable from '../components/EntityOverview/DatasetTable'

const ApiContent = styled(Content)`
  @media (min-width: 1200px) {
    width: 1200px;
  }
`

const Downloads = () => {
  const { t } = useTranslation()

  const priceAreaMetaData = useFetchMetaData('price-areas')
  const gridAreaMetaData = useFetchMetaData('grid-areas')
  const municipalitiesMetaData = useFetchMetaData('municipalities')

  if (!priceAreaMetaData || !gridAreaMetaData || !municipalitiesMetaData) {
    return <div>Loading...</div>
  }

  const filteredPriceAreaMetaData = {
    ...priceAreaMetaData,
    data: {
      ...priceAreaMetaData.data,
      attributes: {
        ...priceAreaMetaData.data.attributes,
        datasets: priceAreaMetaData.data.attributes.datasets.filter(dataset => dataset.openDataSet && dataset.exportable)
      }
    }
  }

  const filteredGridAreaMetaData = {
    ...gridAreaMetaData,
    data: {
      ...gridAreaMetaData.data,
      attributes: {
        ...gridAreaMetaData.data.attributes,
        datasets: gridAreaMetaData.data.attributes.datasets.filter(dataset => dataset.openDataSet && dataset.exportable)
      }
    }
  }

  const filteredMunicipalitiesMetaData = {
    ...municipalitiesMetaData,
    data: {
      ...municipalitiesMetaData.data,
      attributes: {
        ...municipalitiesMetaData.data.attributes,
        datasets: municipalitiesMetaData.data.attributes.datasets.filter(dataset => dataset.openDataSet && dataset.exportable)
      }
    }
  }

  return (
    <TopContainer>
      <ApiContent>
        <VerticalSpace size='2' />
        <Heading size='large' spacing>
          {t(LabelMessages.Downloads as any)}
        </Heading>
        <BodyLong>Open datasets available for download as .csv file. The files contain the last 3 years of data and are updated daily.</BodyLong>
        <DatasetTable datasets={filteredPriceAreaMetaData.data.attributes.datasets} download entity='price-areas' />
        <DatasetTable datasets={filteredGridAreaMetaData.data.attributes.datasets} download entity='grid-areas' />
        <DatasetTable datasets={filteredMunicipalitiesMetaData.data.attributes.datasets} download entity='municipalities' />
      </ApiContent>
    </TopContainer>
  )
}

export default Downloads
